export const JSON_HEADERS = {
    'Content-Type': 'application/json'
};
let isRefreshing = false;

export const apiFetch = async (url: string, options: RequestInit = {}): Promise<Response> => {
    const optionsWithCsrf = addCsrfToken(options);
    const response = await fetch(url, optionsWithCsrf);
    if (response.status === 401) {
        if (globalThis.location.pathname === '/login' ||
            globalThis.location.pathname.startsWith('/reset-password')) {
            return response;
        }

        if (!isRefreshing) {
            isRefreshing = true;
            try {
                await refreshAccessToken();
                return fetch(url, optionsWithCsrf);
            } finally {
                isRefreshing = false;
            }
        }
    }

    return response;
};

export const handleResponse = (response: Response, errorMessage: string): void => {
    if (!response.ok) {
        throw new Error(errorMessage);
    }
};

export function toQueryString(params: Record<string, any>): string {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
        if (v != null) {
            if (Array.isArray(v)) {
                v.forEach(item => qs.append(k, item));
            } else {
                qs.append(k, String(v));
            }
        }
    });
    return qs.toString();
}

const getCsrfToken = (): string | null => {
    const cookies = document.cookie.split(';');
    for (const item of cookies) {
        const cookie = item.trim();
        if (cookie.startsWith('XSRF-TOKEN=')) {
            return cookie.substring('XSRF-TOKEN='.length, cookie.length);
        }
    }
    return null;
};

const addCsrfToken = (options: RequestInit): RequestInit => {
    const csrfToken = getCsrfToken();
    if (
        csrfToken &&
        options.method &&
        ['POST', 'PUT', 'DELETE', 'PATCH'].includes(options.method.toUpperCase())
    ) {
        const headers = new Headers(options.headers || {});
        headers.set('X-XSRF-TOKEN', csrfToken);

        return {
            ...options,
            headers
        };
    }
    return options;
};

const refreshAccessToken = async (): Promise<void> => {
    const options = {method: 'POST'};
    const response = await fetch('/api/refresh-token', addCsrfToken(options));
    if (!response.ok) {
        throw new Error('Token refresh failed.');
    }
};